import { useNavigate } from "react-router-dom";
import Hamburger from "../icons/Hamburger";

const pages = ["home", "projects", "experience", "education", "publications", "talks"];


const Header = () => {

    const navigate = useNavigate();

    const handleRoute = (index) => {
        navigate(`/${pages?.[index]}`)
    }

    return (
        <>
            <header className="fixed top-0 left-0 z-20 w-full h-24 bg-background animate-fade-down animate-once animate-duration-[1500ms] animate-delay-100 animate-ease-in-out border-b border-accent">
                <nav className="h-full flex items-center justify-between mx-4 gap-2">
                    <div className="w-full lg:w-1/2 h-full flex flex-col items-start justify-center">
                        <h1 className="font-bold text-text md:text-xl xl:text-2xl text-2xl">
                            Dr Phil Juricev
                        </h1>
                        <h3 className="text-accent font-semibold text-base sm:text-lg xl:text-lg block ">Software Engineer</h3>
                    </div>
                    <div className="hidden lg:flex gap-4">
                        {
                            pages.map((each, i) => {
                                return (
                                    <button onClick={() => handleRoute(i)} key={i} className="hover:-translate-y-1 transition-transform transform py-1 px-5 text-text xl:text-lg md:text-base font-bold capitalize bg-transparent border rounded-xl border-accent hover:bg-accent hover:cursor-pointer">
                                        {each}
                                    </button>
                                )
                            })
                        }
                    </div>
                    <Hamburger pages={pages} handleRoute={handleRoute}/>
                </nav>
            </header>
        </>
    )
}

export default Header